import React from 'react';
import { IconProps } from '../types/types';

const CHR: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" fill="#201A26"/><path d="M9.885 5.002C12.388 4.935 15 6.52 15 8.974c0 0-2.578 0-2.59-.033-.366-.911-1.19-1.263-2.16-1.27-1.403-.009-2.586 1.1-2.557 2.475.027 1.348 1.181 2.385 2.557 2.376.97-.007 1.628-.358 2.093-1.27.018-.034 2.664-.064 2.657 0-.266 2.312-2.408 3.654-4.75 3.744-2.815.109-5.165-2.09-5.248-4.85-.082-2.743 2.085-5.068 4.883-5.144Z" fill="#FFB0C3"/><path d="M13 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="#CA8FE9" fillOpacity=".6"/></svg>
);

export default CHR;
